<template>
    <div class="vld-parent">
      <v-main>
        <v-container fluid class="px-10">
  
          <v-row class="justify-space-between">
            <v-col>
              <p style="color: #4477ad; font-size: 26px">
                {{ $t('Customers Logados X Customers Registrados') }}
              </p>
            </v-col>
          </v-row>
  
          <v-card :loading="loading" style="margin-bottom: 1rem;">
            <template slot="progress">
              <v-progress-linear color="deep-purple" height="10" indeterminate></v-progress-linear>
            </template>
            <v-expansion-panels v-model="panel" multiple>
              <v-expansion-panel>
                <v-expansion-panel-header class="pl-4" expand-icon="mdi-menu-down">
                  Filtros ({{ countFiltro() }})
                </v-expansion-panel-header>
                <v-expansion-panel-content>
                  <form @submit.prevent="submit()">
                    <v-col class="pb-0 mb-0" cols="12" md="12">
                      <v-container fluid>
                        <v-row align="center">
                          <v-col class="pb-0 mb-0 pt-0" cols="12" sm="4" md="2">
                            <v-text-field v-model="optionsFiltro.cliente" label="Nombre del Cliente"
                              placeholder="Cliente X" outlined dense />
                          </v-col>
                          <v-col class="pb-0 mb-0 pt-0" cols="12" sm="4" md="2">
                            <v-text-field v-model="optionsFiltro.codigo" label="Código del Cliente" placeholder="123456"
                              outlined dense type="number" />
                          </v-col>
  
                          <v-col cols="12" sm="4" md="2" lg="2">
                            <input-date v-model="dataInicial" :label="$t('Fecha de Inicio')" :rules="[]"
                              @click:clear="clearField(dataInicial)" readonly dense />
                          </v-col>
                          <v-col cols="12" sm="4" md="2" lg="2">
                            <input-date v-model="dataFinal" :label="$t('Fecha Final')" readonly
                              @click:clear="clearField(dataFinal)" dense />
                          </v-col>
                          <v-col class="pb-0 mb-0 pt-0" cols="12" sm="4" md="2" lg="2"
                            v-if="isAdministradorGlobal === 'true'">
                            <v-select :items="select" label="País" v-model="optionsFiltro.country" outlined
                              clearable></v-select>
                          </v-col>
                          <v-col cols="12" sm="4" md="2" lg="3" style="padding-bottom: 40px;">
                            <v-layout align-center justify-space-between>
                              <v-btn @click="clear"> Limpiar </v-btn>
                              <v-btn color="primary" class="mr-0" @click="submit()" :disabled="disabled">
                                Buscar
                              </v-btn>
                            </v-layout>
                          </v-col>
                          <v-col cols="12" sm="2" md="2" lg="2">
                            <v-btn class="ma-2 mr-0 mt-2 primary" label small @click="downloadOrders()" :disabled="disabled">
                              <v-icon left> mdi-microsoft-excel </v-icon>
                              Exporta para excel
                            </v-btn>
                          </v-col>
                        </v-row>
  
                      </v-container>
                    </v-col>
                  </form>
                </v-expansion-panel-content>
              </v-expansion-panel>
            </v-expansion-panels>
          </v-card>
  
          <v-card class="mx-auto">
            <v-container fluid>
              <v-row class="d-flex justify-center">
                <v-col cols="4" lg="5">
                  <v-card :loading="loading">
                    <template slot="progress">
                      <v-progress-linear color="deep-purple" height="10" indeterminate></v-progress-linear>
                    </template>
                    <v-expansion-panels v-model="panel" multiple>
                      <v-expansion-panel>
                        <v-expansion-panel-content style="padding: 20px;">
                          <ViewChartJsConectados title="Conectados" :chart-data="this.datacollection"/>
                        </v-expansion-panel-content>
                      </v-expansion-panel>
                    </v-expansion-panels>
                  </v-card>
                </v-col>
                <v-col cols="4" lg="6">
                  <v-card :loading="loading">
                    <template slot="progress">
                      <v-progress-linear color="deep-purple" height="10" indeterminate></v-progress-linear>
                    </template>
                    <v-expansion-panels v-model="panel" multiple>
                      <v-expansion-panel>
                        <v-expansion-panel-content style="padding: 20px; text-align: center;">
                          <h1>Conectados</h1>
                          <v-progress-circular :rotate="-90" :size="150" :width="15" :value="value" color="primary">
                            {{ value }}
                          </v-progress-circular>
                        </v-expansion-panel-content>
                      </v-expansion-panel>
                    </v-expansion-panels>
                  </v-card>
                </v-col>
              </v-row>
            </v-container>
          </v-card>

          <template>
            <v-data-table
              :headers="headers"
              :items="desserts"
              :items-per-page="5"
              class="elevation-1"
            ></v-data-table>
          </template>
  
        </v-container>
      </v-main>
  
  
  
    </div>
  </template>
  <style scoped>
  .tab-usa-active {
    border-top: 0px !important;
  }
  
  .quant-div {
    min-width: 65px;
  }
  
  .min-110 {
    min-width: 110px;
  }
  
  .min-160 {
    min-width: 160px;
  }
  
  .min-130 {
    min-width: 130px;
  }
  
  .v-progress-circular .v-progress-circular--visible .indigo--text .text--darken-2 {
    height: 17rem !important;
    width: 44rem !important;
  }
  </style>
  
  <script lang="ts">
  
  import ViewChartJsConectados from "../ChartComponents/ViewChartJsConectados/ViewChartJsConectados.vue";
  import "../../../assets/css/style.css";
  import InputDate from "@/arch/components/InputDate";
  import axios from 'axios';
  import utils from '@/utils';
  import config from '@/config';
  import XLSX from 'xlsx/xlsx';
  export default {
    name: 'ViewNavegacao',
    components: {
      ViewChartJsConectados,
      InputDate,
    },
    data() {
      return {
        headers: [
          {
            text: 'Customer',
            align: 'start',
            sortable: false,
            value: 'customer',
          },
          { text: 'Customer', value: 'customerName' },
          { text: 'Data del Login', value: 'dataAcesso' },
          { text: 'Nome', value: 'nome' },
          { text: 'E-mail', value: 'email' },
        ],
        desserts: [],
        panel: [0],
        loading: false,
        select: [
          'AR',
          'BO',
          'CL',
          'PE',
          'PY',
          'EC',
          'CO',
          'UY',
        ],
        optionsFiltro: {
          cliente: '',
          codigo: '',
          dataInicial: '',
          dataFinal: '',
          country: '',
        },
        isAdministrador: false,
        isAdministradorGlobal: false,
        datacollection: null,
        dataMostAccessed: null,
        arrayMesAno: ["January", "February", "March", "April", "May", "June", "July", "August", "September", "October", "November", "December"],
        value: 0,
        valuePercent: 0,
        disabled: false,
        dataImplementDash: '2023-01-01',
        dataInicial: '',
        dataFinal: '',
      }
    },
    created() {
      this.isAdministrador = localStorage.getItem('isAdministrador')
      this.isAdministradorGlobal = localStorage.getItem('isAdministradorGlobal')
      if(!this.isAdministradorGlobal){
        this.submit();
      }
    },
    mounted() {
      this.datacollection = {
        labels: [],
        datasets: []
      };
  
      this.dataMostAccessed = {
        labels: [],
        datasets: []
      };
    },
    methods: {
      countFiltro() {
        let countFilter = 0;
  
        if (this.optionsFiltro.cliente != '') {
          countFilter++;
        }
  
        if (this.optionsFiltro.codigo != '') {
          countFilter++;
        }
  
        if (this.optionsFiltro.dataInicial != '') {
          countFilter++;
        }
  
        if (this.optionsFiltro.dataFinal != '') {
          countFilter++;
        }
  
        if (this.optionsFiltro.country != '') {
          countFilter++;
        }
  
        return countFilter;
      },
      async submit() {
  
        this.loading = true
        this.disabled = true
  
        let country = utils.loadCountry();
        let userid = utils.loadUserId();
        let arrayMesAno = this.arrayMesAno;
  
        this.datacollection = {
          labels: [],
          datasets: []
        };
  
        this.dataMostAccessed = {
          labels: [],
          datasets: []
        };
  
        this.optionsFiltro.isExcel = false;
  
        await axios.get(`${config.VUE_APP_API_URL}venusa/getDataUserLogin`, { params: { UNIDADE_PAIS: country, USERID: userid, filter: this.optionsFiltro, TOKEN: utils.loadToken() } })
          .then(({ data }) => {
  
            if (data.erro) {
              this.loading = false;
              this.disabled = false;
              alert('No se encontró ningún registro para el filtro');
              return false;
            }
  
            let arrayLabel = [];
            let arrayData = [];
            let arrayDataDesconectado = [];
            let countUserLogin = 0;
            let countTotUserLogin = 0;
            
            Object.keys(data.loginUserClient).sort().forEach(function (key) {
              arrayData.push(data.loginUserClient[key]);
              countUserLogin += data.loginUserClient[key];
            });
  
            Object.keys(data.totUserClient).sort().forEach(function (key) {
              arrayLabel.push(arrayMesAno[key - 1]);
              arrayDataDesconectado.push(data.totUserClient[key]);
              countTotUserLogin += data.totUserClient[key];
            });
  
            this.value = (countUserLogin * 100) / countTotUserLogin;
            this.value = this.value.toFixed() + '%';
  
            this.datacollection = {
              labels: arrayLabel,
              datasets: [
                {
                  label: "Conectados",
                  backgroundColor: "#87CEEB",
                  data: arrayData
                },
                {
                  label: "Registrados",
                  backgroundColor: "#C0C0C0",
                  data: arrayDataDesconectado
                }
              ]
            };

            this.desserts = data.listCustomers;
          });
  
  
        //   await axios.get(`${config.VUE_APP_API_URL}venusa/getPagesMostAccessed`, { params: { UNIDADE_PAIS: country, USERID: userid, filter: this.optionsFiltro, TOKEN: utils.loadToken() } })
        //   .then(({ data }) => {
  
        //     if (data.erro) {
        //       this.loading = false;
        //       this.disabled = false;
        //       alert('No se encontró ningún registro para el filtro');
        //       return false;
        //     }
  
        //     let arrayLabel = [];
        //     let arrayData = [];
        //     Object.keys(data.arrPage).sort().forEach(function (key) {
        //       arrayLabel.push(key);
        //       arrayData.push(data.arrPage[key])
        //     });
  
        //     this.dataMostAccessed = {
        //       labels: arrayLabel,
        //       datasets: [
        //         {
        //           label: "Acessos",
        //           backgroundColor: "#87CEEB",
        //           data: arrayData
        //         }
        //       ]
        //     };
  
        //   });
  
          this.loading = false;
          this.disabled = false;
      },
      clear() {
        this.optionsFiltro = {
          cliente: '',
          codigo: '',
          dataInicial: '',
          dataFinal: '',
          country: '',
          select: 'AR',
        }
      },
      downloadOrders() {
        this.loading = true;
        this.disabled = true;
  
        let country = utils.loadCountry();
        let userid = utils.loadUserId();
  
        axios.get(`${config.VUE_APP_API_URL}venusa/getDataUserLoginExport`, { params: { UNIDADE_PAIS: country, USERID: userid, filter: this.optionsFiltro, TOKEN: utils.loadToken() } })
          .then(({ data }) => {
  
            if (data.erro) {
              this.loading = false;
              this.disabled = false;
              alert('No se encontró ningún registro para el filtro');
              return false;
            }
  
            let headerArray = [[
              'CUSTOMER',
              'CLIENTE',
              'Data del Login',
              'Usuario',
              'Correio Usuario'
            ]];
  
            data.loginUserClient.map(function (result) {
              headerArray.push(
                [
                  result.customer,
                  result.cliente,
                  result.dataLogin,
                  result.userLogin,
                  result.userEmail
                ]);
            });
  
            let ws_name = 'UserLogin'
            let wb = XLSX.utils.book_new()
            let ws = XLSX.utils.aoa_to_sheet(headerArray)
            XLSX.utils.book_append_sheet(wb, ws, ws_name)
  
            this.wb = wb
  
            this.downloadFile(ws_name)
  
  
            this.loading = false;
            this.disabled = false;
          });
      },
    //   downloadMostAccessed(){
    //     this.loading = true;
    //     this.disabled = true;
  
    //     let country = utils.loadCountry();
    //     let userid = utils.loadUserId();
  
    //     this.optionsFiltro.isExcel = true;
  
    //     axios.get(`${config.VUE_APP_API_URL}venusa/getPagesMostAccessed`, { params: { UNIDADE_PAIS: country, USERID: userid, filter: this.optionsFiltro, TOKEN: utils.loadToken() } })
    //       .then(({ data }) => {
  
    //         if (data.erro) {
    //           this.loading = false;
    //           this.disabled = false;
    //           alert('No se encontró ningún registro para el filtro');
    //           return false;
    //         }
  
    //         let headerArray = [[
    //           'Page Acesso',  
    //           'CUSTOMER',
    //           'CLIENTE',
    //           'Data del Acesso',
    //           'Usuario',
    //           'Correio Usuario'
    //         ]];
  
    //         Object.keys(data.arrPage).sort().forEach(key => {
    //           Object.keys(data.arrPage[key]).sort().forEach(result => {
    //             headerArray.push(
    //               [
    //                 key,
    //                 data.arrPage[key][result].customer,
    //                 data.arrPage[key][result].customerNome,
    //                 data.arrPage[key][result].dataAcesso,
    //                 data.arrPage[key][result].nome,
    //                 data.arrPage[key][result].email
    //               ]);
    //           });
    //         });
  
    //         let ws_name = 'PageMostAccessed'
    //         let wb = XLSX.utils.book_new()
    //         let ws = XLSX.utils.aoa_to_sheet(headerArray)
    //         XLSX.utils.book_append_sheet(wb, ws, ws_name)
  
    //         this.wb = wb
  
    //         this.downloadFile(ws_name)
  
  
    //         this.loading = false;
    //         this.disabled = false;
    //       });
    //   },
      downloadFile(nameFile) {
        let filename = nameFile + '.xlsx'
        XLSX.writeFile(this.wb, filename)
      },
    },
    watch: {
      dataInicial() {
        if (this.dataImplementDash <= this.dataInicial) {
          this.optionsFiltro.dataInicial = this.dataInicial;
          return false;
        }
        this.dataInicial = '';
        alert('No se permite buscar periodos inferiores al 01/01/2023');
      },
      dataFinal() {
        if (this.dataImplementDash <= this.dataFinal) {
          this.optionsFiltro.dataFinal = this.dataFinal;
          return false;
        }
        this.dataFinal = '';
        alert('No se permite buscar periodos inferiores al 01/01/2023');
      },
    },
  }
  </script>